import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    items: [
      { id: 1, name: "Chilling day", date: "2020-09-12T14:00", done: false },
      { id: 2, name: "Mourning day", date: "2020-08-31T14:00", done: false },
      { id: 3, name: "Just day", date: "2020-09-01T13:00", done: false }
    ],
    isTimerOpened: false,
    currentItem: {}
  },
  mutations: {
    add(state, payload) {
      state.items.push(payload);
    },
    edit(state, payload) {
      let item = state.items[payload.index];
      item.name = payload.name;
      item.date = payload.date;
    },
    remove(state, payload) {
      state.items.splice(payload.index, 1);
    },
    open(state, payload) {
      state.isTimerOpened = !state.isTimerOpened;
      state.currentItem = state.items[payload.index];
      state.currentItem = { ...state.currentItem, index: payload.index };
    },
    close(state) {
      state.isTimerOpened = !state.isTimerOpened;
    },
    setDone(state) {
      state.currentItem.done = true;
    }
  },
  actions: {},
  modules: {}
});
